import { TagOverrides } from 'baseui/tag';
import { THEME } from '@lyon/utils/theme';

export const TAG: TagOverrides = {
  Root: {
    style: {
      backgroundColor: THEME.colors.darkmuted500,
    },
  },
  Text: {
    style: {
      color: THEME.colors.primaryA,
      opacity: 0.8,
      maxWidth: 'inherit',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
};
